import { render, staticRenderFns } from "./CameraAttendance.vue?vue&type=template&id=110ff0ac&scoped=true"
import script from "./CameraAttendance.vue?vue&type=script&lang=js"
export * from "./CameraAttendance.vue?vue&type=script&lang=js"
import style0 from "./CameraAttendance.vue?vue&type=style&index=0&id=110ff0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110ff0ac",
  null
  
)

export default component.exports